import { QuestionBase } from '@app/core/models/question/question-base';

export class DropdownQuestion extends QuestionBase<string> {
  controlType = 'dropdown';
  options: {
    key: string, value: string, dependsOn: {
      key: string,
      value: string
    }
  }[] = [];

  ancestorOptions: {
    key: string, value: string, dependsOn: {
      key: string,
      value: string
    }
  }[] = [];

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
    this.ancestorOptions = this.options;
  }

  filterOptions(dependsOn): boolean {
    let optionsChanged = false;

    const options = [];
    if (dependsOn.key === this.key) {
      return;
    }

    this.ancestorOptions.forEach((option) => {

      if (!option.dependsOn) {
        options.push(option);
      } else if (option.dependsOn.key === dependsOn.key && option.dependsOn.value === dependsOn.value) {
        optionsChanged = true;
        options.push(option);
      }
    });

    this.options = options;

    return optionsChanged;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/question/dropdown-question.ts